import { Box } from '@mui/material';
import { useContext } from 'react';
import { IS_SA } from '../../../../../config/appConfig';
import { InvestorStepperContext } from '../../../../../context/investorStepperContext';
import { PersonalInfoKSA } from './ksa';
import { PersonalInfoGlobalIndex } from './global';

export const InvestorPersonalInfo = () => {
    const { isKsaInternationalInvestor } = useContext(InvestorStepperContext);
    const useGlobalInvestorFlow = !IS_SA || isKsaInternationalInvestor;
    return (
        <Box>{useGlobalInvestorFlow ? <PersonalInfoGlobalIndex /> : <PersonalInfoKSA />}</Box>
    );
};
